<template>
  <div class="row">
    <div
        class="col-md-6 col-xl-4 col-sm-6 mb-4"
        v-for="product in products"
        :key="product.id"
    >
      <ProductCard
          :product="product"
          :selected="isSelected(product.id)"
          @toggle="onToggle"
      />
    </div>
  </div>
</template>

<script>
  import ProductCard from "./ProductCard.vue";

  export default {
    name: "ProductGrid",
    components: { ProductCard },
    props: {
      products: Array,
      cartItems: Array
    },
    methods: {
      isSelected(id) {
        return this.cartItems.some(item => item.id === id);
      },
      onToggle(product) {
        const found = this.cartItems.find(p => p.id === product.id);
        if (found) {
          this.$emit("remove-from-cart", product.id);
        } else {
          this.$emit("add-to-cart", { ...product, quantity: 1 });
        }
      }
    }
  };
</script>
